import styled from "styled-components";

export const StyledPortfolioImagesWrapper = styled.div`
  background-color: #fafafa;
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
export const StyledPortfolioImagesItemListWrapper = styled.div`
  border: 1px solid #d9d9d9;
  padding: 8px;
  border-radius: 5px;
`;
